import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ImageGallery from "react-image-gallery";
import Backdrop from "../../../UI/Backdrop/Backdrop";
import ScreenshotViewer from "../../../common/ScreenshotViewer/ScreenshotViewer";
import {
  renderLeftNav,
  renderRightNav,
  renderPlayPauseButton,
  renderFullscreenButton,
} from "./components/Controls";

import "./styles.scss";

const Screenshots = () => {
  const loading = useSelector((state) => state.analysisReports.screenshotsLoading);
  const screenShotsFiles = useSelector((state) => state.analysisReports.screenshots);
  const [items, setItems] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [viewerOpen, setViewerOpen] = useState(false);

  useEffect(() => {
    if (screenShotsFiles) {
      const imageGalleryItems = screenShotsFiles.map((ssFile) => ({
        original: `data:image/jpeg;base64,${ssFile}`,
        thumbnail: `data:image/jpeg;base64,${ssFile}`,
        bulletClass: "small-bullet",
      }));
      setItems(imageGalleryItems);
    }
  }, [screenShotsFiles]);

  // "View All", the expand button and a click on the image open the in-page
  // viewer at the current screenshot instead of the browser's full screen
  const openViewer = () => {
    if (items.length) setViewerOpen(true);
  };

  return (
    <div className="analysis-reports__body-block__screenshots border">
      <Backdrop show={loading} absolute={true} />
      <div className="analysis-reports__body-block__screenshots-header">
        <h3 className="article">Screenshots of File Activity</h3>
        {!loading && (
          <button
            onClick={openViewer}
            className="analysis-reports__body-block__screenshots-header__button">
            View All
          </button>
        )}
      </div>

      {!loading && (
        <div className="analysis-reports__body-block__screenshots__image-gallery">
          <ImageGallery
            items={items}
            showBullets={true}
            thumbnailPosition="right"
            onSlide={setCurrentIndex}
            onClick={openViewer}
            renderLeftNav={renderLeftNav}
            renderRightNav={renderRightNav}
            renderPlayPauseButton={renderPlayPauseButton}
            renderFullscreenButton={() => renderFullscreenButton(openViewer, false)}
          />
        </div>
      )}

      <ScreenshotViewer
        show={viewerOpen}
        onClose={() => setViewerOpen(false)}
        images={items.map((item) => ({ src: item.original }))}
        startIndex={currentIndex}
        title="Screenshots of File Activity"
      />
    </div>
  );
};

export default Screenshots;
